import React, { forwardRef } from 'react'
import BaseTextInput, { TextInputProps } from './BaseTextInput'

const TextInput = (props: TextInputProps, ref) => (
  <BaseTextInput ref={ref} {...props} />
)

export default forwardRef(TextInput)
